import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { financialAssetSeizedItemValidator } from './validators/item';
import { FinancialAssetSeizedModel } from './types';

const financialAssetSeizedValidator: ValidateJSModel<FinancialAssetSeizedModel> = {
  HasAssetSeized: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasAssetSeized?.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: financialAssetSeizedItemValidator,
        },
      };
    }

    return {};
  },
};

export default financialAssetSeizedValidator;
